import { useRef, useState, useCallback, useEffect } from 'react';
import '../../utils/responsive.es.js';
import { useDebouncedCallback } from '../../hooks/useDebouncedCallback/useDebouncedCallback.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';

var middleEllipsis = function middleEllipsis(parentNode, childNode, ellipsis) {
  if (ellipsis === void 0) {
    ellipsis = "...";
  }

  var childWidth = childNode.offsetWidth;
  var containerWidth = parentNode.offsetWidth;
  var txtWidth = childNode.offsetWidth;
  var targetWidth = childWidth > txtWidth ? childWidth : txtWidth;
  var ellipsisLength = ellipsis.length + 2;

  if (targetWidth > containerWidth) {
    var str = childNode.textContent || "";
    var txtChars = str.length;
    var avgLetterSize = txtWidth / txtChars;
    var canFit = (containerWidth - (targetWidth - txtWidth)) / avgLetterSize;
    var delEachSide = (txtChars - canFit + ellipsisLength) / 2;
    var endLeft = Math.floor(txtChars / 2 - delEachSide);
    var startRight = Math.ceil(txtChars / 2 + delEachSide);
    childNode.setAttribute("data-original", str);
    childNode.textContent = "" + str.substring(0, endLeft) + ellipsis + str.substring(startRight);
  }
};

var useTruncate = function useTruncate(props) {
  var mode = props.mode,
      ellipsis = props.ellipsis;
  var containerRef = useRef(null);

  var _useState = useState(false),
      isReady = _useState[0],
      setIsReady = _useState[1];

  var _useState2 = useState(null),
      content = _useState2[0],
      setContent = _useState2[1];

  var truncateText = useCallback(function () {
    var container = containerRef.current;

    if (mode !== "middle") {
      setIsReady(true);
      return;
    }

    if (!container) return;
    var childNode = container.childNodes[0];

    if (childNode instanceof HTMLElement) {
      if (container.hasAttribute("title")) {
        var originalText = container.getAttribute("title");

        if (originalText) {
          childNode.textContent = originalText;
        }
      }

      middleEllipsis(container, childNode, ellipsis);
      setContent(childNode.textContent);
      setIsReady(true);
    }
  }, [ellipsis, mode]);
  var debouncedTruncateText = useDebouncedCallback(truncateText, 0);
  useEnhancedEffect(function () {
    if (!containerRef.current) return;
    setIsReady(false);
    var resizeObserver = new ResizeObserver(debouncedTruncateText);
    resizeObserver.observe(containerRef.current);
    var mutationObserver = new MutationObserver(debouncedTruncateText);
    mutationObserver.observe(containerRef.current, {
      childList: true,
      subtree: true,
      characterData: true
    });
    return function () {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [debouncedTruncateText]);
  useEffect(function () {
    debouncedTruncateText();
  }, [debouncedTruncateText, content]);
  return {
    containerRef: containerRef,
    isReady: isReady
  };
};

export { middleEllipsis, useTruncate };